export default () => {
  const offset = new Date().getTimezoneOffset()
  const hours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, '0')
  const minutes = Math.abs(offset % 60).toString().padStart(2, '0')
  const sign = offset > 0 ? '-' : '+'
  return `${sign}${hours}:${minutes}`
}